export default {
  title: 'KI-Vorschläge',
  subtitle: 'Vorschläge des FoodAmigos-Agenten für deine Restaurants.',
  empty: 'Hier gibt es nichts anzuzeigen.',
  tabs: {
    pending: 'Offen',
    history: 'Verlauf',
  },
  table: {
    id: 'ID',
    company: 'Restaurant',
    type: 'Typ',
    summary: 'Vorschlag',
    created_at: 'Erstellt',
    status: 'Status',
    actions: 'Aktionen',
  },
  statuses: {
    pending: 'Offen',
    confirmed: 'Bestätigt',
    applied: 'Angewendet',
    rejected: 'Abgelehnt',
    failed: 'Fehlgeschlagen',
    expired: 'Abgelaufen',
  },
  types: {
    'smart_pricing.global_reduce': 'Rabatt auf die ganze Karte',
    'smart_pricing.category_reduce': 'Rabatt auf Kategorie',
    'competitor_listing.confirm': 'Marktplatz-Eintrag bestätigen',
    'catalog.price_correct': 'Preiskorrektur',
    'catalog.add_item': 'Fehlenden Artikel hinzufügen',
    'catalog.quality': 'Inhaltsqualität',
    'catalog.reorder': 'Menü neu sortieren',
  },
  actions: {
    review: 'Prüfen',
    confirm: 'Bestätigen',
    reject: 'Ablehnen',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
  },
  edit: {
    label: 'Beschreibe die gewünschte Änderung (es wird eine neue Version erstellt)',
    placeholder: 'Beschreibe die gewünschte Änderung',
    placeholders: {
      'smart_pricing.global_reduce': 'z. B. mach 15 %, nenn es „Sommer -15%“ oder lass es nur für Lieferung laufen',
      'smart_pricing.category_reduce': 'z. B. setze den Rabatt für Getränke auf 10 % und entferne Abholung',
      'catalog.price_correct': 'z. B. entferne die Korrektur für „Cola“ oder setze „Pizza“ auf 7,50 €',
      'catalog.add_item': 'z. B. entferne „Wasser“ oder setze „Falafel Wrap“ auf 6,50 €',
      'catalog.quality': 'z. B. entferne „Pommes“ und „Cola“ aus der Liste',
      'catalog.reorder': 'z. B. stell Getränke nach hinten und den Bestseller in Bowls nach oben',
      'competitor_listing.confirm': 'z. B. ersetze den Uber-Eats-Link durch https://… oder füge Wolt hinzu: https://…',
    },
    submit: 'Version erstellen',
  },
  revisions: {
    label: 'Version',
    original: 'Original',
    revision_n: 'Version {{n}}',
  },
  detail: {
    title: 'Vorschlagsdetails',
    targets: 'Betroffene Artikel',
    evidence: 'Warum der Agent das vorschlägt',
    no_targets: 'Keine Artikeldetails vorhanden.',
    composed_from: 'Zusammengeführt aus',
    items_suffix: 'Artikel',
    nutrition: 'Nährwerte',
    uncategorized: 'Ohne Kategorie',
    decided_by: 'Entschieden von',
    decision_note: 'Notiz',
    category_existing: 'vorhanden',
    category_new: 'neu',
    product: 'Artikel',
    price_change: 'Preisänderung',
    no_items: 'Keine Artikel',
    fills_image: '+ Bild',
    fills_description: '+ Beschreibung',
    fills_nutrition: '+ Nährwerte',
    fills_modifiers: '+ Optionen',
    competitor_links: 'Wettbewerber-Links',
    no_competitor_links: 'Noch keine aufgelösten Wettbewerber-Links.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Diesen Vorschlag ablehnen',
    note_label: 'Grund',
    note_placeholder: 'Erkläre kurz, warum du diesen Vorschlag ablehnst',
  },
  toasts: {
    load_failed: 'Vorschläge konnten nicht geladen werden',
    confirmed: 'Vorschlag bestätigt',
    rejected: 'Vorschlag abgelehnt',
    action_failed: 'Aktion konnte nicht abgeschlossen werden',
    revision_created: 'Neue Version erstellt',
    revision_failed: 'Aus dieser Anweisung konnte keine Version erstellt werden',
    choose_revision: 'Dieser Vorschlag hat mehrere Versionen — öffne ihn und wähle eine zum Bestätigen',
  },
};
